// extracted by mini-css-extract-plugin
module.exports = {"tags":"TagsDetail-module--tags--PlOO0","innerContainer":"TagsDetail-module--inner-container--1plJt","tagsList":"TagsDetail-module--tags-list--3jNjc"};